module.exports = __webpack_public_path__ + "static/ins1-6656f8d6f2c26f909cc36265bd223a90.png";